import React from "react";
import { useTranslation } from "react-i18next";
import PromptDialog from "components/__reusable/PromptDialog";

interface DeletePromptDialogProps {
  onNoClick: () => void;
  onYesClick: () => void;
}

const DeletePromptDialog: React.FC<DeletePromptDialogProps> = ({
  onNoClick,
  onYesClick,
}) => {
  const { t } = useTranslation();

  return (
    <PromptDialog
      title={t("_published_picture._delete_prompt_header")}
      message={t("_published_picture._delete_prompt_message")}
      onCancel={onNoClick}
      onConfirm={onYesClick}
      cancelText={t("_generic._no")}
      confirmText={t("_generic._yes")}
    />
  );
};

export default DeletePromptDialog;
